// DEPENDENCIES
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import SignatureCanvas from 'react-signature-canvas';
import { useFormik } from "formik";
// COMPONENTS
import { useParams } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import MaskedInput from 'react-maskedinput';
// CUSTOM COMPONENTS
import Section from '../../../../components/Section';
import ContentBlock from '../../../../components/ContentBlock';
import Overlay from '../../../../components/Overlay';
import CustomBlock from '../../../../components/CustomBlock';
import ContentHeader from '../../../../components/ContentHeader';
import Button from '../../../../components/Button';
//SERVICES AND HELPERS
import * as confirmModal from '../../../../../redux/confirmModalRedux';
import * as alert from '../../../../../redux/alertSnackBarRedux';
import { formatToUSDate } from "../../../../../helpers/helper";
import LeadAirWorkerAcknowledgementFormValidator from '../../../../../helpers/validators/LeadAirWorkerAcknowledgementFormValidator';
import * as leadAirWorkerAcknowledgementFormService from '../../../../../services/form/leadAirWorkerAcknowledgementFormService';

const initialState = {
    id: 0,
    leadAirDataSheetLineItemId: 0,
    signature: '',
    jobForm: {},
    translatorName: '',
    translatorSignature: '',
    requireTranslator: false,
    signatureDate: '',
    leadAirWorkerAcknowledgementFormId: 0,
}

const LeadAirWorkerAcknowledgementForm = (props) => {
    const iframeRef = useRef();
    const { jobFormId, edit } = useParams();
    const { showAlert } = props;
    const [jobForm, setJobForm] = useState({});
    const [sigRef, setSigRef] = useState(null);
    const [translatorSigRef, setTranslatorSigRef] = useState(null);
    const [switchMode, setSwitchMode] = useState(false);
    const [loading, setLoading] = useState(false)
    const [leadAirWorkerAcknowledgementFormId, setLeadAirWorkerAcknowledgementFormId] = useState(0);
    const [requireTranslator, setRequireTranslator] = useState(false);
    const [reloadPage, setReloadPage] = useState(false)
    const [model, setModel] = useState({ ...initialState });

    useEffect(() => {
        fetchLeadAirWorkerAcknowledgementForm();
    }, [reloadPage]);

    const fetchLeadAirWorkerAcknowledgementForm = () => {
        setLoading(true)
        leadAirWorkerAcknowledgementFormService.getLeadAirWorkerAcknowledgementById(jobFormId).then(res => {
            setModel(res);
            setJobForm(res.jobForm);
            formik.setFieldValue("requireTranslator", res.requireTranslator);
            setRequireTranslator(res.requireTranslator);
            setLeadAirWorkerAcknowledgementFormId(res.jobForm ? res.jobForm.leadAirWorkerAcknowledgementFormId: 0)
            if (edit == 'false') {
                setSwitchMode(true);
                setLeadAirWorkerAcknowledgementFormId(res.jobForm.leadAirWorkerAcknowledgementFormId)
                getReport(res.jobForm.leadAirWorkerAcknowledgementFormId);
            }
        }).finally(() => setLoading(false));
    }

    const validateBase64String = (base64String) => {
        var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;
        return base64regex.test(base64String.split('base64,')[1]);
    }

    const handleFormSubmit = (values, setSubmitting) => {
        leadAirWorkerAcknowledgementFormService.save({ ...values }).then(res => {
            showAlert({ message: res.message, variant: 'success' });
            setReloadPage(!reloadPage);
        }).catch(ex => {
            showAlert({ message: ex.message, variant: 'error' });
        })
    }

    const getReport = (id) => {
        if (id) {
            leadAirWorkerAcknowledgementFormService.getReportPdf(id).then(res => {
                iframeRef.current.src = "data:application/pdf;base64," + res;
            }).catch(ex => {
            })
        }
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: model,
        validationSchema: LeadAirWorkerAcknowledgementFormValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            handleFormSubmit(values, setSubmitting)
        }
    });

    return (
        <>
            {!loading ?
                switchMode
                    ?
                    <iframe ref={iframeRef} style={{ height: '100%', width: '100%' }} title="description"></iframe>
                    :
                    <Section removeContainer>

                        <ContentBlock>
                            <CustomBlock className="content-container--card-style--with-shadow">
                                <ContentHeader
                                    title={`LeadAirWorker Acknowledgement Form`}
                                    headerSize="md"
                                    primaryButtonText="Print Form"
                                    primaryButtonBackgroundColor="info--bg mr-0"
                                    primaryButtonOnClick={() => {
                                        setSwitchMode(true);
                                        getReport(leadAirWorkerAcknowledgementFormId);
                                    }}
                                />

                                <form className="card card-custom" onSubmit={formik.handleSubmit}>

                                    <CustomBlock>
                                        <Section removeContainer className="pb-10">
                                            <ContentBlock cols={9}>
                                                <ContentHeader
                                                    title={`LeadAirWorker Information:`}
                                                    headerSize="sm"
                                                    className="fw-700 pb-5"
                                                />
                                                <ContentHeader
                                                    title={`Please enter signature for ${model.employeeName}`}
                                                    headerSize="sm"
                                                    className="fw-500 pb-5"
                                                />
                                                <div className="form-group row">
                                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        LeadAirWorker Signature
                                                    </label>
                                                    <div className="col-lg-9 col-xl-6">
                                                        <SignatureCanvas
                                                            penColor='black'
                                                            backgroundColor='aliceblue'
                                                            canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                                                            ref={ref => {
                                                                setSigRef(ref);
                                                                if (ref && formik.values.signature) {
                                                                    ref.fromDataURL(formik.values.signature);
                                                                }
                                                            }}
                                                            onEnd={() => {
                                                                var dataUrl = { ...sigRef }.toDataURL();
                                                                if (validateBase64String(dataUrl)) {
                                                                    formik.setFieldValue('signature', dataUrl.toString());
                                                                }
                                                            }}
                                                        />
                                                        {formik.touched.signature && formik.errors.signature ? (
                                                            <div className="invalid-feedback display-block">
                                                                {formik.errors.signature}
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Signature Date
                                                    </label>
                                                    <div className="col-lg-9 col-xl-6">
                                                        <div className="input-group input-group-lg input-group-solid">
                                                            <DatePicker
                                                                value={formik.getFieldProps('signatureDate').value && formik.getFieldProps('signatureDate').value !== '0001-01-01T00:00:00' ? formatToUSDate(formik.getFieldProps('signatureDate').value) : null}
                                                                dateFormat="MM/dd/yyyy"
                                                                selected={formik.getFieldProps('signatureDate').value && formik.getFieldProps('signatureDate').value !== '0001-01-01T00:00:00' ? new Date(formik.getFieldProps('signatureDate').value) : null}
                                                                customInput={
                                                                    <MaskedInput
                                                                        className={`form-control form-control-lg form-control-solid}`}
                                                                        mask="11/11/1111"
                                                                        placeholder="MM/DD/YYYY"
                                                                    />

                                                                }
                                                                onChange={(date) => {
                                                                    formik.setFieldValue('signatureDate', formatToUSDate(date));
                                                                }}
                                                                onBlur={(e) => {
                                                                    if (e.target.value.includes('_') || e.target.value === "") {
                                                                        formik.setFieldValue('signatureDate', null);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                        {formik.errors.signatureDate ? (
                                                            <div className="invalid-feedback display-block">
                                                                {formik.errors.signatureDate}
                                                            </div>
                                                        ) : null}

                                                    </div>
                                                </div>
                                                <div className="form-group row">
                                                    <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                        Require Translator
                                                    </label>
                                                    <div className="col-lg-9 col-xl-6">
                                                        <label className="checkbox checkbox-primary">
                                                            <input
                                                                name='requireTranslator'
                                                                type="checkbox"
                                                                checked={requireTranslator}
                                                                className={`form-control form-control-lg form-control-solid`}
                                                                onChange={() => {
                                                                    setRequireTranslator(!requireTranslator);
                                                                    formik.setFieldValue("requireTranslator", !requireTranslator)
                                                                }}
                                                            />
                                                            <span></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </ContentBlock>
                                        </Section>
                                        {requireTranslator &&
                                            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                <Button
                                                    text="Clear"
                                                    onClick={() => {
                                                        sigRef.clear();
                                                        formik.setFieldValue('signature', '');
                                                    }
                                                    }
                                                    className="info--bg"
                                                />
                                            </div>
                                        }
                                        {
                                            requireTranslator &&
                                            <Section removeContainer className="pb-10">
                                                <ContentBlock>
                                                    <ContentHeader
                                                        title={`Translator Information:`}
                                                        headerSize="sm"
                                                        className="fw-700 pb-10"
                                                    />
                                                </ContentBlock>
                                                <ContentBlock cols={9}>
                                                    <div className="form-group row">
                                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                            Translator Name
                                                        </label>
                                                        <div className="col-lg-9 col-xl-6">
                                                            <input
                                                                placeholder="Translator Name"
                                                                className={`form-control form-control-lg form-control-solid`}
                                                                name="translatorName"
                                                                {...formik.getFieldProps("translatorName")}
                                                            />
                                                            {formik.touched.translatorName && formik.errors.translatorName ? (
                                                                <div className="invalid-feedback display-block">
                                                                    {formik.errors.translatorName}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </ContentBlock>
                                                <ContentBlock cols={9}>
                                                    <div className="form-group row">
                                                        <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                                            Translator Signature
                                                        </label>
                                                        <div className="col-lg-9 col-xl-6">
                                                            <SignatureCanvas
                                                                penColor='black'
                                                                backgroundColor='aliceblue'
                                                                canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
                                                                ref={ref => {
                                                                    setTranslatorSigRef(ref);
                                                                    if (ref && formik.values.translatorSignature) {
                                                                        ref.fromDataURL(formik.values.translatorSignature);
                                                                    }
                                                                }}
                                                                onEnd={() => {
                                                                    var dataUrl = { ...translatorSigRef }.toDataURL();
                                                                    if (validateBase64String(dataUrl)) {
                                                                        formik.setFieldValue('translatorSignature', dataUrl.toString());
                                                                    }
                                                                }}
                                                            />
                                                            {formik.touched.translatorSignature && formik.errors.translatorSignature ? (
                                                                <div className="invalid-feedback display-block">
                                                                    {formik.errors.translatorSignature}
                                                                </div>
                                                            ) : null}
                                                        </div>
                                                    </div>
                                                </ContentBlock>
                                            </Section>
                                        }

                                    </CustomBlock>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                        <Button
                                            text="Clear"
                                            onClick={() => {
                                                if (requireTranslator) {
                                                    translatorSigRef.clear();
                                                    formik.setFieldValue("translatorSignature", '')
                                                }
                                                else {
                                                    sigRef.clear();
                                                    formik.setFieldValue("signature", '')
                                                }

                                            }
                                            }
                                            className="info--bg"
                                        />
                                        &nbsp;
                                        <Button
                                            text="Submit"
                                            type="submit"
                                            className="info--bg"
                                        />
                                    </div>
                                </form>

                            </CustomBlock>
                        </ContentBlock>
                    </Section>
                :
                <Overlay />
            }
        </>
    )
}

const mapStateFromProps = (state) => ({
    auth: state.auth
})

export default connect(mapStateFromProps, {
    ...alert.actions,
    ...confirmModal.actions
})(LeadAirWorkerAcknowledgementForm);